var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_vm._v("Redirect to "+_vm._s(_vm.$route.query.oauth_url))])
}
var staticRenderFns = []

export { render, staticRenderFns }